module.exports = __webpack_public_path__ + "media/images/email-icon-white-ba5eb19beaee300adecc5ee5d057d568.png";